import React from 'react';
import KristalKYCForm from '../components/forms/KristalKYCForm';

export default function KristalOnboardingPage() {
    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
            <KristalKYCForm />
        </div>
    );
}
